import styled from 'styled-components';

const hexToRGBA = (hex: string, alpha: number) => {
  const [r1, r2, g1, g2, b1, b2] = hex.replace('#', '').split('');
  return `rgba(${parseInt(r1 + r2, 16)}, ${parseInt(g1 + g2, 16)}, ${parseInt(
    b1 + b2,
    16
  )}, ${alpha})`;
};

export const LightPrimaryBg = styled.p`
  background-color: ${(props) => hexToRGBA(props.theme.primary, 0.3)};
`;



// WEBPACK FOOTER //
// ./src/views/Links/components/LightPrimaryBg.tsx